import { BundleElement } from './BundleElement';
import { OfferElement } from './OfferElement';
import type { ElementType } from '@xshop/shared';
import type { ElementComponent } from './elementRenderContext';
import { ColumnElement, ContainerElement, RowElement, SectionElement } from './StructureElements';
import { HeadingElement, ListElement, ParagraphElement } from './TextElements';
import { AudioElement, IconElement, ImageElement, VideoElement } from './MediaElements';
import { BlockLinkElement, ButtonElement, LinkElement } from './ActionElements';
import { CustomHtmlElement, DividerElement, SpacerElement } from './SpacingElements';
import { MenuElement } from './MenuElement';
import { CartElement, SearchElement } from './CommerceElements';
import { SlideshowElement } from './SlideshowElement';
import { TabsElement } from './TabsElement';
import { AccordionElement } from './AccordionElement';
import { MarqueeElement } from './MarqueeElement';
import { ProductScopeElement } from './ProductScope';
import { BreadcrumbsElement } from './BreadcrumbsElement';
import { ProductMediaElement } from './ProductMediaElement';
import { PurchaseElement, CheckoutElement, OrderSummaryElement } from './PurchaseElement';
import { SocialLinksElement } from './SocialLinksElement';
import { ReviewListElement } from './ReviewListElement';
import { ListingFiltersElement } from './ListingFiltersElement';
import { ListingToolbarElement } from './ListingToolbarElement';
import { ListingPaginationElement } from './ListingPaginationElement';
import { StickyBuyElement } from './StickyBuyElement';
import { CartPageElement } from './CartPageElement';
import { OrderLookupElement } from './OrderLookupElement';
import { PopupElement } from './PopupElement';
import { SwatchesElement } from './SwatchesElement';
import { CollectionListElement, ProductListElement } from './CatalogElements';

// The types this folder draws, keyed by the name the schema stores. The other fifty-two live
// in `elements/commerce/` and `elements/interactive/`; the walker takes those as wiring, so a type
// nobody has written yet draws nothing rather than breaking the page around it.

export const ELEMENT_RENDERERS: Readonly<Partial<Record<ElementType, ElementComponent>>> = {
  section: SectionElement,
  row: RowElement,
  column: ColumnElement,
  container: ContainerElement,
  popup: PopupElement,
  slideshow: SlideshowElement,
  tabs: TabsElement,
  accordion: AccordionElement,
  marquee: MarqueeElement,
  heading: HeadingElement,
  paragraph: ParagraphElement,
  list: ListElement,
  image: ImageElement,
  icon: IconElement,
  video: VideoElement,
  audio: AudioElement,
  button: ButtonElement,
  link: LinkElement,
  'block-link': BlockLinkElement,
  spacer: SpacerElement,
  divider: DividerElement,
  'custom-html': CustomHtmlElement,
  menu: MenuElement,
  cart: CartElement,
  search: SearchElement,
  'collection-list': CollectionListElement,
  'product-list': ProductListElement,
  bundle: BundleElement,
  'product-scope': ProductScopeElement, purchase: PurchaseElement, checkout: CheckoutElement, 'order-summary': OrderSummaryElement, offer: OfferElement,
  breadcrumbs: BreadcrumbsElement, 'product-media': ProductMediaElement, 'social-links': SocialLinksElement, 'review-list': ReviewListElement, swatches: SwatchesElement,
  'listing-filters': ListingFiltersElement, 'listing-toolbar': ListingToolbarElement, 'listing-pagination': ListingPaginationElement, 'sticky-buy': StickyBuyElement, 'cart-contents': CartPageElement, 'order-lookup': OrderLookupElement
};

/** The types this folder draws, as a value, so a catalog check can assert against it rather than guess. */
export const RENDERED_ELEMENT_TYPES = Object.keys(ELEMENT_RENDERERS) as readonly ElementType[];
